import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7y2dnmvs3: FaireProductEntity = {
  token: "p_s7y2dnmvs3",
  type: "product",
  name: "Stuzzi Hot Sauce",
  brandToken: "b_88ntrh9ks5",
  brandName: "Stuzzi Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/0fa3cddda5ebc031f531a3f947720dc7eb850f10e34d33cfa084cdd1b06e0b3a.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cdc5350366d3779bd37f15f884c388db61cc1683c69be2a32b543c938830b9ca.webp",
    "https://cdn.faire.com/fastly/7ca9720fd2d37145ccbabc6d159d6a9a0d5381d54dc54fe5c872dc1b795bcb57.jpeg",
    "https://cdn.faire.com/fastly/994d8b36baadc85874a670ac05e65655216dbbcb5f6be4cf4e0ed33f40270bfc.jpeg",
    "https://cdn.faire.com/fastly/1356eb453caa49645c4aa3e18d1ba3d40e1bdf52654aed4f46310e4b2ac32328.jpeg",
    "https://cdn.faire.com/fastly/71b7e392537917b24f744607d59a292b55de7f88b0076eaec570f5bed8e4551a.jpeg",
    "https://cdn.faire.com/fastly/cc0203b0f8db5b0a33a4abc9ab3fe285554e36933386b4a33843fa104336125f.webp",
    "https://cdn.faire.com/fastly/571a84a16d42286e12ff6038e3d6ab1c8728cb3df01a47a55ef2a9841fd3af44.webp",
    "https://cdn.faire.com/fastly/e50849646c19873c2e60b387ddaeb040b57d5a7fe1a0b71c45fa32ad246068bc.jpeg",
  ],
  priceDollars: 10,
  description:
    "• Made in Italy with Italian Peppers.\n\n• Only 3 ingredients: chilies, distilled vinegar and salt. \n\n• No added preservatives, artificial colors, sweeteners or thickening agents.\n\nStuzzi is a blend of both fresh and dried peppers.\n\nThe Calabrian peppers are slowly dried in the shade in southern Italy. This traditional whole-pepper natural drying process takes 1-2 months, compared to the chopped-chili industrial process (max. 24hr.) This slow step is key to preserving the peppers’ delicate earthiness.\n\nIn order to obtain a layer of bright, high-toned citrus as well as umami, we lacto-ferment fresh cayenne peppers.\n\nStuzzi is the hot sauce for (and made by) people who know good food.\n",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:52.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
